import {
  da,
  de,
  enIE,
  enUS,
  es,
  fi,
  fr,
  frCA,
  is,
  it,
  jaHira,
  ko,
  nl,
  nn,
  pt,
  ptBR,
  sv,
  th,
  tr,
  vi,
} from 'date-fns/locale';

type WebFormConfigDataItemType = {
  form_id: string;
  form_name: string;
  form_status: boolean;
  language: WebformLanguage;
  touchpoint: string;
  touchpoint_name: string;
  touchpoint_status: boolean;
};

export const WebformLanguageMapper = {
  'da-DK': {
    lng: 'Danish (DK)',
    locale: da,
  },
  'de-DE': {
    lng: 'German (DE)',
    locale: de,
  },
  'en-US': {
    lng: 'English (US)',
    locale: enUS,
  },
  'es-ES': {
    lng: 'Spanish (ES)',
    locale: es,
  },
  'fi-FI': {
    lng: 'Finnish (FI)',
    locale: fi,
  },
  'fr-CA': {
    lng: 'French (CA)',
    locale: frCA,
  },
  'fr-FR': {
    lng: 'French (FR)',
    locale: fr,
  },
  'ga-IE': {
    lng: 'Irish (IE)',
    locale: enIE,
  },
  'is-IS': {
    lng: 'Icelandic (IS)',
    locale: is,
  },
  'it-IT': {
    lng: 'Italian (IT)',
    locale: it,
  },
  'ja-JP': {
    lng: 'Japanese (JP)',
    locale: jaHira,
  },
  'ko-KR': {
    lng: 'Korean (KR)',
    locale: ko,
  },
  'nl-NL': {
    lng: 'Dutch (NL)',
    locale: nl,
  },
  'no-NO': {
    lng: 'Norwegian (NO)',
    locale: nn,
  },
  'pt-BR': {
    lng: 'Portuguese (BR)',
    locale: ptBR,
  },
  'pt-PT': {
    lng: 'Portuguese (PT)',
    locale: pt,
  },
  'sv-SE': {
    lng: 'Swedish (SE)',
    locale: sv,
  },
  'th-TH': {
    lng: 'Thai (TH)',
    locale: th,
  },
  'tr-TR': {
    lng: 'Turkish (TR)',
    locale: tr,
  },
  'vi-VI': {
    lng: 'Vietnamese (VI)',
    locale: vi,
  },
};

const languages: WebformLanguage[] = [
  'fi-FI',
  'de-DE',
  'vi-VI',
  'en-US',
  'pt-BR',
  'ko-KR',
  'es-ES',
  'no-NO',
  'fr-CA',
  'it-IT',
  'is-IS',
  'nl-NL',
  'pt-PT',
  'sv-SE',
  'ga-IE',
  'da-DK',
  'tr-TR',
  'fr-FR',
  'ja-JP',
  'th-TH',
];
export const WebformLanguageOptions = languages.map((value) => ({
  value,
  label: WebformLanguageMapper[value].lng,
}));

export type WebformLanguage = keyof typeof WebformLanguageMapper;

export type WebFormConfigModel = {
  web_form_key: string;
  website_url: string;
  data_list: Array<WebFormConfigDataItemType>;
  create_at: string;
  status: boolean;
};

export type WebFormConfigType = Partial<WebFormConfigModel>;
